"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon24Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.PlusIcon24Solid = forwardRef_1.forwardRef('PlusIcon24Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M11.5 2A1.5 1.5 0 0 1 13 3.5V11h7.5a1.5 1.5 0 0 1 0 3H13v7.5a1.5 1.5 0 0 1-3 0V14H2.5a1.5 1.5 0 0 1 0-3H10V3.5A1.5 1.5 0 0 1 11.5 2Z" })));
});
